import React from "react"
import { Button, Dropdown, Tag } from "antd"
import { MoreOutlined } from "@ant-design/icons"

export const getColumns = (getMenuItems, isMutating, t) => [
  {
    title: t("settings.column_title"),
    dataIndex: "title",
    key: "title"
  },
  {
    title: t("settings.column_price"),
    dataIndex: "price",
    key: "price",
    render: (value, record) =>
      record.fee_type === "percentage" ? `${Number(value)?.toFixed(2)}%` : `$${Number(value)?.toFixed(2)}`,
    width: 150
  },
  {
    title: t("settings.column_status"),
    dataIndex: "is_active",
    key: "status",
    width: 120,
    render: (status) =>
      status ? (
        <Tag color="success">{t("settings.status_active")}</Tag>
      ) : (
        <Tag color="default">{t("settings.status_inactive")}</Tag>
      )
  },
  {
    title: "",
    key: "actions",
    align: "right",
    width: 60,
    render: (_, record) => (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items: getMenuItems(record) }} trigger={["click"]} placement="bottomRight" disabled={isMutating}>
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
      </div>
    )
  }
]
